"use client";

import React, { useState } from "react";
import FacilityIcon from "@/src/shared/components/FacilityIcon";
import AllFacilitiesModal from "@/src/shared/components/AllFacilitiesModal";
import SubtleButton from "@/src/shared/components/atoms/SubtleButton";
import type { IFacility } from "@/src/shared/types/listing";
import { cn } from "@/src/lib/utils";

/** The app shows 5 before "Show all"; desktop has room for two columns of 5. */
const ON_MOBILE = 5;
const ON_DESKTOP = 10;

/** "What this place offers": the app's icon rows, then every amenity in a dialog. */
const ListingAmenities: React.FC<{ facilities: IFacility[] }> = ({
  facilities,
}) => {
  const [showAll, setShowAll] = useState(false);
  const sorted = [...facilities].sort((a, b) => a.order - b.order);
  const shown = sorted.slice(0, ON_DESKTOP);

  return (
    <section>
      <h2 className="text-xl font-semibold text-ink md:text-22">
        What this place offers
      </h2>
      <ul className="mt-4 grid grid-cols-1 gap-6 md:mt-6 md:grid-cols-2 md:gap-x-8 md:gap-y-5">
        {shown.map((facility, index) => (
          <li
            key={facility.id}
            className={cn(
              "flex items-center gap-4",
              index >= ON_MOBILE && "hidden md:flex",
            )}
          >
            <span className="flex h-6 w-6 shrink-0 items-center justify-center">
              {/* The name is written beside it. */}
              <FacilityIcon src={facility.icon} alt="" />
            </span>
            <span className="text-base leading-6 text-ink">
              {facility.name}
            </span>
          </li>
        ))}
      </ul>
      {/* Mobile hides from the 6th; desktop from the 11th. */}
      {sorted.length > ON_MOBILE && (
        <SubtleButton
          className={cn(
            "mt-6 md:mt-8",
            sorted.length <= ON_DESKTOP && "md:hidden",
          )}
          onClick={() => setShowAll(true)}
        >
          Show all {sorted.length} amenities
        </SubtleButton>
      )}
      <AllFacilitiesModal
        open={showAll}
        onClose={() => setShowAll(false)}
        facilities={sorted}
      />
    </section>
  );
};

export default ListingAmenities;
